"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderingErrorHandler = void 0;
const React = require("react");
const react_1 = require("react");
const SalesOrderContext_1 = require("../../contexts/SalesOrderContext");
const ErrorResolver_1 = require("../../../../../contexts/ErrorResolver");
/**
 * Handles errors while the customer is ordering. This includes cart updates, retrieving carts, missing carts as well as the checkout
 * process.
 *
 * This will work on both web and native versions
 */
const OrderingErrorHandler = ({ children }) => {
    const { resolveError } = (0, react_1.useContext)(ErrorResolver_1.ErrorResolverContext);
    const { isPerformingCartRecovery, resetCart, setHasSalesOrderError, cartNoLongerExists, processSalesOrderError, retrieveTemporarySalesOrderError, setTemporarySalesOrderError } = (0, react_1.useContext)(SalesOrderContext_1.SalesOrderContext);
    // show error modal if sales order error occurs
    (0, react_1.useEffect)(() => {
        // if there is no api error there's no point proceeding
        const hasOrderApiError = processSalesOrderError ||
            retrieveTemporarySalesOrderError ||
            setTemporarySalesOrderError;
        if (!hasOrderApiError) {
            return;
        }
        // if there is an error during processing checkout, we don't want to show the modal and just display the error message on the
        // checkout screen
        if (processSalesOrderError) {
            return;
        }
        showError();
    }, [
        processSalesOrderError,
        retrieveTemporarySalesOrderError,
        setTemporarySalesOrderError
    ]);
    // show error message describing the nature of the issue
    const showError = (0, react_1.useCallback)(async () => {
        if (processSalesOrderError) {
            return;
        }
        if (isPerformingCartRecovery || cartNoLongerExists) {
            // need to reset the cart if we were trying to recover it but couldn't or the cart is missing
            await resetCart(true);
        }
        else {
            // error message to show to the customer
            const title = "An error occurred while updating the cart. Please try again.";
            resolveError({
                title,
                approach: "modal",
                canDismiss: true,
                hideCloseIcon: true
            });
        }
        // reset error state
        setHasSalesOrderError(false);
    }, [isPerformingCartRecovery, cartNoLongerExists, processSalesOrderError]);
    return React.createElement(React.Fragment, null, children);
};
exports.OrderingErrorHandler = OrderingErrorHandler;
//# sourceMappingURL=index.js.map